import { Injectable, signal } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Observable, tap } from 'rxjs';
import { LocationsResponse, LocationDto } from '../models/locations.model';

@Injectable({ providedIn: 'root' })
export class LocationsService extends BaseApiService {
  public readonly locations = signal<LocationDto[] | null>(null);

  getLocations(): Observable<LocationsResponse> {
    return this.get<LocationsResponse>('/locations').pipe(
      tap((locations) => this.locations.set(locations.locations)),
    );
  }
}
